export default {
  // 用户操作
  login(_this, param, next, err) { // 登录
    _this.$axios.post('/Groups/SupplierLogin', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  modifyPsw(_this, param, next, err) { // 修改密码
    _this.$axios.post('/Groups/SupplierModifyPwd', param).then(res => {
      next(res);
    })
  },
  addUser(_this, param, next, err) { // 添加人员
    _this.$axios.post('/User/AddUser', param).then(res => {
      next(res);
    })
  },
  getAllUser(_this, param, next, err) { // 查询人员
    _this.$axios.post('/User/GetAll', param).then(res => {
      next(res);
    })
  },
  logout(_this, next) { // 退出
    _this.$axios.get('/logout').then(res => {
      next(res);
    })
  },
  handleGroupsInfo(_this, param, next, err) { // 同步/查询 集团信息
    _this.$axios.post('/Groups/HandleGroupsInfo', param).then(res => {
      next(res);
    })
  },
  handleSuppliersInfo(_this, param, next, err) { // 同步/查询 供应商信息
    _this.$axios.post('/Groups/HandleSuppliersInfo', param).then(res => {
      next(res);
    })
  },
  searchGroupsLogin(_this, param, next, err) { // 查询集团账户信息
    _this.$axios.post('/Groups/SearchGroupsLogin', param).then(res => {
      next(res);
    })
  },
  handleMonthsAmoData(_this, param, next, err) { // 月金额汇总处理
    _this.$axios.post('/SalesData/HandleMonthsAmoData', param).then(res => {
      next(res);
    })
  },
  handleMonthsBillsData(_this, param, next, err) { // 月份结算单
    _this.$axios.post('/SalesData/HandleMonthsBillsData', param).then(res => {
      next(res);
    })
  },
  getBillsItems(_this, param, next, err) { // 根据结算单号获取明细
    _this.$axios.post('/SalesData/GetBillsItems', param).then(res => {
      next(res);
    })
  },
  getSumAmoByBrand(_this, param, next, err) { // 获取供应商结算单汇总明细
    _this.$axios.post('/SalesData/GetSumAmoByBrand', param).then(res => {
      next(res);
    })
  },
  searchAmoByGroupId(_this, param, next, err) { // 根据集团id获取金额汇总
    _this.$axios.post('/SalesData/SearchAmoByGroupId', param).then(res => {
      next(res);
    })
  },
  searchBillsByGroupId(_this, param, next, err) { // 根据集团id获取结算单
    _this.$axios.post('/SalesData/SearchBillsByGroupId', param).then(res => {
      next(res);
    })
  },
  columnClassManage(_this, param, next, err) { // 栏目新增/修改
    _this.$axios.post('/InfoManage/ColumnClassManage', param).then(res => {
      next(res);
    })
  },
  columnClassDelete(_this, param, next, err) { // 栏目删除
    _this.$axios.post('/InfoManage/ColumnClassDelete', param).then(res => {
      next(res);
    })
  },
  searchColumnClass(_this, param, next, err) { // 栏目查找
    _this.$axios.post('/InfoManage/SearchColumnClass', param).then(res => {
      next(res);
    })
  },
  searchMessage(_this, param, next, err) { // 查询信息
    _this.$axios.post('/InfoManage/SearchMessage', param).then(res => {
      next(res);
    })
  },
  publishMessage(_this, param, next, err) { // 发布信息
    _this.$axios.post('/InfoManage/PublishMessage', param).then(res => {
      next(res);
    })
  },
  deleteMessage(_this, param, next, err) { // 删除信息
    _this.$axios.post('/InfoManage/DeleteMessage', param).then(res => {
      next(res);
    })
  },
  auditMessage(_this, param, next, err) { // 审核信息
    _this.$axios.post('/InfoManage/AuditMessage', param).then(res => {
      next(res);
    })
  },
  searchMessageByID(_this, param, next, err) { // 根据id查询消息
    _this.$axios.get('/InfoManage/SearchMessageByID', param).then(res => {
      next(res);
    })
  },
  getLatestTopNews(_this, param, next, err) { // 获取最新头条信息
    _this.$axios.get('/InfoManage/GetLatestTopNews', param).then(res => {
      next(res);
    })
  },
}